import { Component, Input, OnChanges, ChangeDetectorRef, Output, EventEmitter } from '@angular/core';
import { ICustomerPhoto } from '../user-photo-submissions.component';

@Component({
    selector: 'app-photo-viewer',
    templateUrl: './photo-viewer.component.html',
    styleUrls: ['./photo-viewer.component.scss'],
})
export class PhotoViewerComponent implements OnChanges {
    @Input() photos: ICustomerPhoto[];
    @Input() veiwingPhotoIndex: number;
    @Output() closed: EventEmitter<void> = new EventEmitter<void>();
    @Output() flipped: EventEmitter<number> = new EventEmitter<number>();
    @Output() winnerSelected: EventEmitter<ICustomerPhoto> = new EventEmitter<ICustomerPhoto>();

    selectedPhoto: ICustomerPhoto = null;

    constructor() {}

    ngOnChanges(): void {
        this.selectedPhoto = this.photos[this.veiwingPhotoIndex];
    }

    close() {
        this.closed.emit();
    }

    downloadImage(url) {
        const filename = url.split('/').pop();
        const xhr = new XMLHttpRequest();
        xhr.responseType = 'blob';
        xhr.withCredentials = true;
        xhr.onload = function () {
            const a = document.createElement('a');
            a.href = window.URL.createObjectURL(xhr.response);
            a.download = filename;
            a.style.display = 'none';
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
        };
        xhr.open('GET', url);
        xhr.send();
    }

    prevClicked(e) {
        if (this.veiwingPhotoIndex > 0) {
            this.flipped.emit(--this.veiwingPhotoIndex);
        }
        e.preventDefault();
        e.stopPropagation();
    }

    nextClicked(e) {
        if (this.veiwingPhotoIndex < this.photos.length - 1) {
            this.flipped.emit(++this.veiwingPhotoIndex);
        }
        e.preventDefault();
        e.stopPropagation();
    }

    setAsWinner(e) {
        this.winnerSelected.emit(this.selectedPhoto);
        this.closed.emit();
        e.preventDefault();
        e.stopPropagation();
    }
}
